export default __webpack_public_path__ + "ce48de502eb1dd236140b0121bd3430f.png";